<template>
  <div class="dialog-wrap">
    <el-dialog
      title="参数管理"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="660px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="130px"
      >
        <el-form-item
          label="父权限"
          v-if="dataForm.pid"
        >
          <el-input
            v-model="content.parent.name"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="名称"
          prop="name"
        >
          <el-input
            v-model="dataForm.name"
            placeholder="请输入权限名称"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="单位"
          prop="unit"
          v-if="dataForm.pid"
        >
          <div class="unit-wrap">
            <el-input
              v-model="dataForm.unit"
              placeholder="请输入单位"
              style="width:150px;margin-right:16px;"
              :disabled="checked"
            ></el-input>
            <el-checkbox v-model="checked">无</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item
          label="编码"
          prop="code"
        >
          <el-input
            v-model="dataForm.code"
            placeholder="请输入编码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="图标"
          prop="icon_url"
        >
          <el-upload
            class="cover-uploader"
            :action="imgUploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="handleBeforeUpload"
          >
            <img
              v-if="dataForm.icon_url"
              :src="dataForm.icon_url"
              class="cover"
            >
            <i
              v-else
              class="el-icon-plus cover-uploader-icon"
            ></i>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="内容类型"
          prop="type"
        >
          <el-select
            v-model="dataForm.type"
            placeholder="请选择"
            style="width: 100%;"
          >
            <el-option
              label="目录"
              :value="1"
            >
            </el-option>
            <el-option
              label="参数"
              :value="2"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="dataForm.pid">
          <el-form-item
            label="是否关联院校"
            prop="is_ref_college"
          >
            <el-select
              v-model="dataForm.is_ref_college"
              placeholder="请选择"
              style="width: 100%;"
            >
              <el-option
                label="是"
                :value="1"
              >
              </el-option>
              <el-option
                label="否"
                :value="0"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否关联专业"
            prop="is_ref_major"
          >
            <el-select
              v-model="dataForm.is_ref_major"
              placeholder="请选择"
              style="width: 100%;"
            >
              <el-option
                label="是"
                :value="1"
              >
              </el-option>
              <el-option
                label="否"
                :value="0"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否关联年份"
            prop="is_ref_year"
          >
            <el-select
              v-model="dataForm.is_ref_year"
              placeholder="请选择"
              style="width: 100%;"
            >
              <el-option
                label="是"
                :value="1"
              >
              </el-option>
              <el-option
                label="否"
                :value="0"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否关联列表"
            prop="is_ref_multi"
          >
            <el-select
              v-model="dataForm.is_ref_multi"
              placeholder="请选择"
              style="width: 100%;"
            >
              <el-option
                label="是"
                :value="1"
              >
              </el-option>
              <el-option
                label="否"
                :value="0"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否为系统参数"
            prop="is_ref_multi"
          >
            <el-select
              v-model="dataForm.content_type"
              placeholder="请选择"
              style="width: 100%;"
            >
              <el-option
                label="是"
                :value="1"
              >
              </el-option>
              <el-option
                label="否"
                :value="0"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item
          label="备注"
          prop="remark"
        >
          <el-input
            type="textarea"
            v-model="dataForm.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="排序值"
          prop="status"
        >
          <el-input
            type="text"
            v-model="dataForm.sort"
            placeholder="请输入排序值"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="状态"
          prop="status"
        >
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { paramEdit } from '@/api/query'
import { imgUploadUrl, uploadHeaders } from '@/config/index'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {
        pid: this.content.id,
      },
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        code: [{ required: true, message: '请选择编码', trigger: 'blur' }],
        unit: [{
          required: true,
          validator: (rule, value, callback) => {
            if (this.checked) {
              callback()
            } else {
              if (this.dataForm.unit) {
                callback()
              } else {
                callback(new Error('请输入省市区'))
              }
            }
          },
        }],
        is_ref_college: [{ required: true, message: '请选择是否关联院校', trigger: 'blur' }],
        is_ref_major: [{ required: true, message: '请选择是否关联专业', trigger: 'blur' }],
        is_ref_year: [{ required: true, message: '请选择是否关联年份', trigger: 'blur' }],
        is_ref_multi: [{ required: true, message: '请选择是否关联列表', trigger: 'blur' }],
      },
      checked: false,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      if (val) {
        this.dataForm = val

        if (!this.dataForm.unit) {
          this.checked = true
        } else {
          this.checked = false
        }
      }
    }
  },
  methods: {
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.icon_url = res.data.url
        console.log(this.dataForm);
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm, { status: this.dataForm.status ? 1 : 0 })
          if (this.checked) {
            params.unit = ""
          }
          delete params.children
          delete params.parent
          paramEdit(params).then(res => {
            this.$message.success(`添加成功`)
            this.$refs['dataForm'].resetFields()
            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      delete this.dataForm.pid
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}

.cover-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100%;
}
.cover-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}
.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  max-width: 100%;
  max-height: 200px;
  line-height: 100px;
  text-align: center;
}
.cover {
  display: block;
  max-width: 100%;
  max-height: 200px;
  object-fit: cover;
  margin: 0 auto;
}
.ref-box {
  /deep/ .el-input__inner {
    border-style: dashed;
  }
}
.unit-wrap {
  display: flex;
}
</style>
